
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/search",
      function () {
        return require("private-next-pages/app/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/search"])
      });
    }
  